import React, { useState } from 'react';
import { Modal, Form, Tooltip } from 'antd';
import { Button } from '@digital/ui';
import TextArea from 'antd/lib/input/TextArea';
import { salvarJustificativaNaoAplicavel } from '@app/api/controleQaqc';
import { hasPermission } from '@app/helpers/permissions';

export interface PropsModalJustificativaNaoAplicavel {
  controleQaQcId: string;
  reload: () => void;
}

const ModalJustificativaNaoAplicavel = ({ controleQaQcId, reload }: PropsModalJustificativaNaoAplicavel) => {
  const [exibirModal, setExibirModal] = useState(false);
  const textAreaId = `textAreaId${controleQaQcId}`;

  const limparCampo = () => {
    const elemento = document.getElementById(textAreaId);
    if (elemento != null) {
      document.getElementById(textAreaId).value = '';
    }
  };

  const handleCancel = () => {
    limparCampo();
    setExibirModal(false);
    reload();
  };


  const Salvar = (e: any) => {
    const text = document.getElementById(textAreaId).value;
    const form = new FormData();
    form.append('controleQaqcId', controleQaQcId);
    form.append('justificativa', text);

    salvarJustificativaNaoAplicavel(form).then(data => {
      if (data.valid) {
        handleCancel();
      }
    });
  };

  return (
    <>
      <Tooltip title="Não Aplicável">
        <Button
          onClick={() => {
            setExibirModal(true);
          }}
          icon="messaging-comments"
        >
          Não Aplicável
        </Button>
      </Tooltip>
      <Modal
        title="INCLUIR JUSTIFICATIVA"
        visible={exibirModal}
        onCancel={() => {
          handleCancel();
        }}
        footer={[
          <Button key="submitEnviar" type="link" onClick={e => Salvar(e)}>
            Confirmar
          </Button>,
          <Button key="submitCancelar" type="primary" onClick={() => handleCancel()}>
            Fechar
          </Button>,
        ]}>
        <Form>
          <Form.Item>
            <span>Justificativa da não aplicabilidade</span>
            <TextArea
              id={textAreaId}
              placeholder="Informe a justificativa"
              autosize={{ minRows: 1, maxRows: 1 }} />
          </Form.Item>
        </Form>
      </Modal>
    </>
  );
};

export default ModalJustificativaNaoAplicavel;
